<template>
  <div class="user-machine-line-product jt-table">
    <dialog-or-inline
      :embedded="embedded"
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineUser.devicePosition')"
      :visible.sync="dialogMachineMaps"
      width="75%"
      top="9vh"
      @closed="closeDialog"
      @open="handlerOpenDialog"
      :close-on-click-modal="false"
    >
      <div style="display: none">
        <input id="pac-input" class="controls" type="text" :placeholder="$t('machineConfig.pEnterMapTips')" />
      </div>
      <el-row>
        <div style="display: flex; align-items: center">
          <span>{{ $t("machineConfig.address") }}:</span>
          <div class="autocomplete-wrapper" ref="autocompleteContainer" style="flex: 1"></div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="margin-bottom: 10px">
            <span style="display: inline-block; min-width: 80px">{{ $t("machineConfig.mapLng") }}:</span>
            <el-input v-model="longitude" style="width: 150px; margin-left: 10px"></el-input>
          </div>
        </el-col>
        <el-col :span="24">
          <div style="">
            <span style="display: inline-block; min-width: 80px">{{ $t("machineConfig.mapLat") }}:</span>
            <el-input v-model="latitude" style="width: 150px; margin-left: 10px"></el-input>
          </div>
        </el-col>
        <!-- <el-col :span="14">
					<div style="font-size: 12px; color: #ee3f4d; margin-top: 10px">
						{{ $t("machineConfig.mapPs") }}
					</div>
				</el-col> -->
      </el-row>
      <!-- 地图暂时注释掉 因为key有问题报错 -->
      <!-- <div
				id="mapBox"
				v-loading.fullscreen.lock="fullscreenLoading"
				style="display: flow-root; height: 600px;"
			></div> -->

      <div id="infowindow-content">
        <div class="title" style="font-size: 18px">{{ place_name }}</div>
        <div style="width: 100%; display: flow-root; margin: 3px 0 2px 0">
          <strong>Place ID</strong>: <span>{{ place_id }}</span>
        </div>
        <div>{{ address }}</div>
        <div @click="handleJZ" style="color: var(--vtm-info); margin-top: 5px; text-decoration: underline; cursor: pointer">
          <span>Locate to the periphery</span>
          <span class="el-icon-s-promotion" style="margin-left: 3px; text-decoration: underline"></span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm()">{{ $t("common.definite") }}</el-button>
      </div>
    </dialog-or-inline>
  </div>
</template>

<script>
  import { Loader } from "@googlemaps/js-api-loader";
  import DialogOrInline from "./DialogOrInline";
  var map = null;
  var localGoogle = null;
  //   var infowindowContent = null;
  //   var mapBox = null;
  //   var input = null;

  const loader = new Loader({
    apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
    version: "weekly",
    libraries: ["places"]
  });

  export default {
    name: "UserMachineMap",
    components: { DialogOrInline },
    props: {
      dialogMachineMaps: Boolean,
      userEquipment: Object,
      embedded: { type: Boolean, default: false }
    },
    mounted() {
      if (this.embedded) this.handlerOpenDialog();
    },
    data() {
      return {
        loading: false,
        longitude: "",
        latitude: "",
        address: "",
        place_id: "",
        place_name: "",
        fullscreenLoading: true
      };
    },
    methods: {
      handlerOpenDialog() {
        this.initMap();
        this.$nextTick(() => {
          this.initializeGoogleAutocomplete();
        });
      },
      async initializeGoogleAutocomplete() {
        const googleMaps = await loader.load();
        // Create the autocomplete input element
        // @ts-ignore
        const placeAutocomplete = new googleMaps.maps.places.PlaceAutocompleteElement();

        // Inject into Vue DOM
        const container = this.$refs.autocompleteContainer;
        // 此处会导致重现上次配置的元素信息 所以必须初始化元素
        // if (container && !container.firstChild) {
        //   container.appendChild(placeAutocomplete);
        // }
        if (container) {
          // 清空 container 中的所有内容
          container.innerHTML = "";
          // 重新插入 placeAutocomplete
          container.appendChild(placeAutocomplete);
        }

        // Handle input changes to clear coordinates when input is empty
        placeAutocomplete.addEventListener("input", e => {
          if (!e.target.value) {
            this.latitude = "";
            this.longitude = "";
          }
        });

        // Handle selection
        // @ts-ignore
        placeAutocomplete.addEventListener("gmp-select", async ({ placePrediction }) => {
          const fullPlace = placePrediction.toPlace();
          await fullPlace.fetchFields({
            fields: ["location", "formattedAddress", "displayName"]
          });
          if (fullPlace.location) {
            this.latitude = fullPlace.location.lat();
            this.longitude = fullPlace.location.lng();
          }
          // Set the address from the selected place
          if (fullPlace.formattedAddress) {
            this.address = fullPlace.formattedAddress;
          } else if (fullPlace.displayName) {
            this.address = fullPlace.displayName;
          } else {
            this.address = placePrediction.description || "";
          }
        });
      },
      handleJZ() {
        let _self = this;
        var myLatlng = new localGoogle.maps.LatLng(parseFloat(_self.latitude), parseFloat(_self.longitude));
        map.setCenter(myLatlng);
        map.setZoom(18);
      },
      initMap() {
        let _self = this;
        if (_self.userEquipment.lng && _self.userEquipment.lat) {
          _self.latitude = parseFloat(_self.userEquipment.lat);
          _self.longitude = parseFloat(_self.userEquipment.lng);
          //   _self.loadMaps(_self.latitude, _self.longitude);
        } else {
          _self.latitude = "";
          _self.longitude = "";
        }
        // 这里的内容是如果没有设置定位会显示在你的个人电脑的定位 如果没给权限那么就是空
        // else {
        //   // 获取当前位置信息（经纬度）
        //   if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(
        //       function (position) {
        //         // locationSuccess 获取成功的话
        //         _self.latitude = position.coords.latitude;
        //         _self.longitude = position.coords.longitude;
        //         _self.loadMaps(_self.latitude, _self.longitude);
        //       },
        //       function (error) {
        //         console.log(error.message);
        //         // 开达工业园位置
        //         let latitude = "";
        //         let longitude = "";
        //         _self.latitude = latitude;
        //         _self.longitude = longitude;
        //         _self.loadMaps(_self.latitude, _self.longitude);
        //       }
        //     );
        //   }
        // }
      },
      //   loadMaps(latitude, longitude) {
      //     let _self = this;
      //     loader
      //       .load()
      //       .then(google => {
      //         localGoogle = google;
      //         let geocoder = new google.maps.Geocoder();
      //         var myLatlng = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
      //         var mapOptions = {
      //           disableDefaultUI: true,
      //           zoom: 2,
      //           center: myLatlng
      //         };
      //         if (document.getElementById("mapBox")) {
      //           mapBox = document.getElementById("mapBox");
      //         }
      //         map = new google.maps.Map(mapBox, mapOptions);
      //         var marker = new google.maps.Marker({
      //           position: myLatlng,
      //           animation: google.maps.Animation.DROP,
      //           map: map,
      //           draggable: true,
      //           title: "Drag me!",
      //           icon: {
      //             url: "/img/position.png", // url
      //             scaledSize: new google.maps.Size(40, 40) // scaled size
      //           }
      //         });
      //         // 设置标注的点击信息窗口
      //         let infowindow = new google.maps.InfoWindow();
      //         if (document.getElementById("infowindow-content")) {
      //           infowindowContent = document.getElementById("infowindow-content");
      //         }
      //         infowindow.setContent(infowindowContent);
      //         if (_self.address) {
      //           infowindow.open(map, marker);
      //         }
      //         // 根据经纬度解析当前地址信息
      //         geocoder
      //           .geocode({ location: myLatlng })
      //           .then(response => {
      //             let totalAddress = response.results;
      //             let zuizhong = "";
      //             let locali = 0;
      //             for (let i = 0; i < totalAddress.length; i++) {
      //               if (zuizhong == "") {
      //                 zuizhong = totalAddress[i].formatted_address;
      //                 locali = i;
      //               } else {
      //                 if (totalAddress[i].formatted_address.length > zuizhong.length) {
      //                   zuizhong = totalAddress[i].formatted_address;
      //                   locali = i;
      //                 }
      //               }
      //             }
      //             if (zuizhong != "") {
      //               _self.address = zuizhong;
      //               _self.place_id = totalAddress[locali]["place_id"];
      //               _self.place_name = "Current Location";
      //               infowindow.open(map, marker);
      //             } else {
      //               window.alert("No results found");
      //             }
      //             // 隐藏加载框
      //             _self.fullscreenLoading = false;
      //           })
      //           .catch(e => window.alert("Geocoder failed due to: " + e));
      //         // 标记拖拽结束触发
      //         marker.addListener("dragend", e => {
      //           // 显示加载框
      //           _self.fullscreenLoading = true;
      //           let latlng = e.latLng;
      //           let lng = latlng.lng();
      //           let lat = latlng.lat();
      //           _self.longitude = parseFloat(lng);
      //           _self.latitude = parseFloat(lat);
      //           // 根据经纬度获取地址信息
      //           geocoder
      //             .geocode({ location: latlng })
      //             .then(response => {
      //               let totalAddress = response.results;
      //               let zuizhong = "";
      //               let locali = 0;
      //               for (let i = 0; i < totalAddress.length; i++) {
      //                 if (zuizhong == "") {
      //                   zuizhong = totalAddress[i].formatted_address;
      //                   locali = i;
      //                 } else {
      //                   if (totalAddress[i].formatted_address.length > zuizhong.length) {
      //                     zuizhong = totalAddress[i].formatted_address;
      //                     locali = i;
      //                   }
      //                 }
      //               }
      //               if (zuizhong != "") {
      //                 _self.address = zuizhong;
      //                 _self.place_id = totalAddress[locali]["place_id"];
      //                 _self.place_name = "Current drag location";
      //                 infowindow.open(map, marker);
      //               } else {
      //                 window.alert("No results found");
      //               }
      //               // 隐藏加载框
      //               _self.fullscreenLoading = false;
      //             })
      //             .catch(e => window.alert("Geocoder failed due to: " + e));
      //         });
      //         // 点击标注时弹出信息窗口
      //         marker.addListener("click", () => {
      //           infowindow.open(map, marker);
      //         });
      //         // 设置地图的自动完成搜索输入框
      //         if (document.getElementById("pac-input")) {
      //           input = document.getElementById("pac-input");
      //         }
      //         let autocomplete = new google.maps.places.Autocomplete(input, {
      //           fields: ["place_id", "geometry", "name", "formatted_address"]
      //         });
      //         // 将搜索输入框绑定到地图上
      //         autocomplete.bindTo("bounds", map);
      //         // 将搜索输入框绑定到地图上的左上方
      //         map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
      //         // 输入框改变事件
      //         autocomplete.addListener("place_changed", () => {
      //           infowindow.close();
      //           let place = autocomplete.getPlace();
      //           if (!place.place_id) {
      //             return;
      //           }
      //           geocoder.geocode({ placeId: place.place_id }, function (results, state) {
      //             if (state == google.maps.GeocoderStatus.OK) {
      //               if (results[0]) {
      //                 let localresults = results[0];
      //                 marker.setPlace({
      //                   placeId: place.place_id,
      //                   location: localresults.geometry.location
      //                 });
      //                 marker.setDraggable(true);
      //                 map.setZoom(18);
      //                 map.setCenter(localresults.geometry.location);
      //                 let lng = localresults.geometry.location.lng();
      //                 let lat = localresults.geometry.location.lat();
      //                 let address = localresults.formatted_address;
      //                 _self.longitude = parseFloat(lng);
      //                 _self.latitude = parseFloat(lat);
      //                 _self.address = address;
      //                 _self.place_id = place.place_id;
      //                 _self.place_name = place.name;
      //                 infowindow.open(map, marker);
      //               }
      //             }
      //           });
      //         });
      //       })
      //       .catch(e => {
      //         _self.fullscreenLoading = false;
      //         console.log(e);
      //       });
      //   },
      cancel(state, code) {
        this.$emit("mapsCancel", false, state, code);
      },
      closeDialog() {
        this.$emit("mapsCancel", false);
      },
      submitForm() {
        let _self = this;
        if (_self.longitude && _self.latitude) {
          console.log("long", _self.longitude);
          this.$api
            .request(this.$url.UserMachine.updatePos, this.$method.put, {
              id: _self.userEquipment.id,
              lng: parseFloat(_self.longitude),
              lat: parseFloat(_self.latitude),
              locale: _self.address  // Send address as locale field for consistency
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("editUserMachine.up"),
                  type: "success"
                });
                // Emit sync event with updated address data
                this.$emit("addressUpdated", {
                  machineNo: _self.userEquipment.equipmentNo,
                  address: _self.address,
                  lat: _self.latitude,
                  lng: _self.longitude,
                  machineId: _self.userEquipment.id
                });
                this.$emit("mapsCancel", false, true);
              }
            })
            .catch(() => {
              this.$notify({
                title: this.$t("common.tip"),
                message: "reqest error",
                type: "warning"
              });
            });
        } else {
          this.$notify({
            title: this.$t("common.tip"),
            message: "xsxsxsx",
            type: "warning"
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .search-box {
    width: 100%;
    padding: 10px;
    font-size: 16px;
  }
  .pac-container {
    z-index: 1000000 !important;
  }
  #mapBox {
    height: 100%;
  }
  .controls {
    background-color: var(--vtm-surface);
    border-radius: 2px;
    border: 1px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
    height: 29px;
    margin-left: 17px;
    margin-top: 10px;
    outline: none;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
  }
  .controls:focus {
    border-color: var(--vtm-mint);
  }
  .title {
    font-weight: bold;
  }
  #infowindow-content {
    display: none;
  }
  #mapBox #infowindow-content {
    display: inline;
  }
  .autocomplete-wrapper {
    padding: 16px;
    font-family: Roboto, sans-serif;
    max-width: 600px;
  }

  gmp-place-autocomplete {
    width: 100%;
    display: block;
    margin-bottom: 12px;
  }

  pre {
    background: var(--vtm-well);
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
  }
</style>
